import { useState, useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { RoleSelection, LanguageSelection } from "./Steps";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    background: theme.palette.background.paper,
  },
  contentContainer: {
    flexGrow: 1,
  },
}));

function Loading({ handleNextStep }) {
  useEffect(() => {
    handleNextStep();
  }, [handleNextStep]);

  return (
    <CircularProgress
      sx={{
        position: "fixed",
        top: "50%",
        right: "50%",
        zIndex: 1500,
      }}
    />
  );
}

const LAST_STEP = 2;

function Onboard({
  t = (text) => text,
  plan,
  handleSelectRole,
  handleSelectLanguage,
  roleOptions = [
    {
      img: "",
      role: "learn",
    },
    {
      img: "",
      role: "teach",
    },
  ],
  languages = [
    "spanish",
    "french",
    "english",
    "italian",
    "german",
    "portuguese",
    "chinese",
    "japanese",
  ],
  preferred_username,
  learnlang,
}) {
  const { classes } = useStyles();
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedRole, setSelectedRole] = useState(0);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const skip = learnlang && plan ? true : false;

  const handleNext = async () => {
    try {
      if (activeStep === 0 && (plan === "teacher_pro" || plan === "teach")) {
        setLoading(true);
        // if teach plan is selected assume 'teach' role and move to next step
        await handleSelectRole("teach");
        setSelectedRole(plan);
        setLoading(false);
        setActiveStep(2);
      }
      if (activeStep === 0 && plan === "learn") {
        if (learnlang && languages.includes(learnlang)) {
          setLoading(true);
          setSelectedRole(plan);
          await handleSelectRole("learn");
          await handleSelectLanguage(learnlang);
          setLoading(false);
        } else {
          setLoading(true);
          await handleSelectRole("learn");
          setSelectedRole(plan);
          setLoading(false);
          setActiveStep(2);
        }
      }
      if (activeStep === 0 && !plan) {
        setActiveStep(1);
      } else {
        // Don't go past the last step
        setActiveStep((prevActiveStep) =>
          prevActiveStep + 1 > LAST_STEP ? prevActiveStep : prevActiveStep + 1,
        );
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handlePrevious = () => {
    // Don't go below the first step
    setActiveStep((prevActiveStep) =>
      prevActiveStep - 1 < 0 ? prevActiveStep : prevActiveStep - 1,
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.contentContainer}>
        {activeStep === 0 && <Loading handleNextStep={handleNext} />}
        {activeStep === 1 && !skip && (
          <RoleSelection
            t={t}
            roleOptions={roleOptions}
            handleNextStep={handleNext}
            handleSelectRole={handleSelectRole}
            selectedRole={selectedRole}
            setSelectedRole={setSelectedRole}
            loading={loading}
            preferred_username={preferred_username}
          />
        )}
        {activeStep === 2 && !skip && (
          <LanguageSelection
            t={t}
            selectedRole={selectedRole}
            languages={languages}
            plan={plan}
            handlePreviousStep={handlePrevious}
            handleNextStep={handleNext}
            handleSelectLanguage={handleSelectLanguage}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
          />
        )}
      </div>
    </div>
  );
}

export default Onboard;
